import { Construction, KeyRound } from "lucide-react";

/** iter361 pt.4 (modèle I2) — icônes de la formule de l'acte, partout : #E0A42E si choisie, sinon #6f6f78, sans fond. */
export const FORMULE_META = {
  acte_vsp: { label: "Acte VSP", sub: "Vente sur plan", Icon: Construction },
  acte_final: { label: "Acte finale", sub: "Bien achevé", Icon: KeyRound },
};
export const FORMULE_ON = "#E0A42E", FORMULE_OFF = "#6f6f78";

export function FormuleIcon({ value, active = true, size = 16, testId }) {
  const m = FORMULE_META[value];
  if (!m) return null;
  const { Icon } = m;
  return <Icon size={size} strokeWidth={1.8} style={{ color: active ? FORMULE_ON : FORMULE_OFF, flexShrink: 0 }} data-testid={testId} data-formule={value} data-active={active} />;
}

/** Icône + libellé (+ sous-titre optionnel) sur une ligne. */
export function FormuleTag({ value, active = true, size = 15, sub = false, fontSize = 11.5, testId }) {
  const m = FORMULE_META[value];
  if (!m) return null;
  const color = active ? FORMULE_ON : FORMULE_OFF;
  return (
    <span className="inline-flex items-center" style={{ gap: 6 }} data-testid={testId} data-formule={value}>
      <FormuleIcon value={value} active={active} size={size} />
      <span style={{ fontSize, fontWeight: active ? 700 : 400, color, lineHeight: 1.1 }}>{m.label}{sub && <span style={{ display: "block", fontSize: 9.5, fontWeight: 400, color: "#8a8a93" }}>{m.sub}</span>}</span>
    </span>
  );
}
